/**
 * UserUpdateRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * UserUpdateRes
 */
export interface UserUpdateRes {
  [key: string]: any
}

/**
 * UserUpdateRes Schema
 */
export const UserUpdateResSchema: SchemaDefinition = {
  properties: {},
  type: 'object',
}
